import { parseJson, replaceKey } from "../../utils/utils";

export const onRowUpdateError = (pushNotification, I18n) => {
    pushNotification({
        open: true,
        message: I18n.translate`Somethings went wrong update field`,
        type: "error",
        timeout: "short",
    });
};

export const onCellHighlightDataGrid = (params) => {
    const { field, row } = params || {};
    const { oldRow = "{}" } = row || {};
    const parsedOldRow = parseJson(oldRow);
    if (field === "audit_logs") return "";
    return Object.keys(parsedOldRow)?.length && row[field] !== parsedOldRow[field]
        ? "highlight"
        : "";
};

export const checkCellHasEditedValues = (cell) => {
    const { id, CLB_ID, oldRow = "{}", ...rest } = cell;
    const parsedOldRow = parseJson(oldRow);
    return !Object.keys(parsedOldRow).length
        ? false
        : Object.keys(rest).some((key) => parsedOldRow?.[key] !== cell[key]);
};

const rawDataByLineMapper = (
    cell,
    header,
    entity,
    projectId,
    fiscalYear,
    importId,
    modulePrefix,
) => {
    const hasAuditLogMoreMenu = checkCellHasEditedValues(cell);
    const { id, CLB_ID } = cell;
    const mapperCell = (header || []).reduce((acc, elem) => {
        const { type, align, label, columnName } = elem;
        const finalObject = [
            {
                type,
                align,
                labels: [`${label}`],
                value: cell[columnName] ?? null,
            },
        ];
        acc.push(finalObject);
        return acc;
    }, []);
    mapperCell.push(
        hasAuditLogMoreMenu
            ? [
                  {
                      labels: ["audit_logs"],
                      value: {
                          customComponent: "PushAuditLogModal",
                          entity,
                          id,
                          CLB_ID,
                          projectId,
                          fiscalYear,
                          importId,
                          modulePrefix,
                      },
                  },
              ]
            : [],
    );
    return mapperCell;
};

export const mapRawDataByLine = (
    rawDataArray = [],
    rawDataHeader,
    entity,
    projectId,
    fiscalYear,
    importId,
    modulePrefix,
) =>
    rawDataArray.map((rawData) => {
        return {
            ...rawData,
            card: rawDataByLineMapper(
                rawData,
                rawDataHeader,
                entity,
                projectId,
                fiscalYear,
                importId,
                modulePrefix,
            ),
        };
    });

export const updateRawDataHeaderArray = (headerArray) => {
    return headerArray?.header?.length
        ? [
              ...headerArray.header.map((headerProps) => ({
                  ...headerProps,
                  // TODO: Revert to this when all translatations for all master schemas are done
                  // Request by PO @Vera.Cristina
                  // headerName: replaceKey(headerProps.headerName)},
                  headerName: `${replaceKey(headerProps.headerName)} `
              })),
              {
                  label: ["audit_logs"],
                  type: "customComponent",
                  align: "right",
                  basis: "5%",
              },
          ]
        : [];
};
